export default "__VITE_ASSET__801d2b23__"